// extracted by mini-css-extract-plugin
export default {"modalContent":"SetupForm_modalContent__5xSiI","title":"SetupForm_title__jv41y","subTitle":"SetupForm_subTitle__gFi2p"};